<template>
  <!--FAQ start-->
  <section class="theme-bg" id="faq" ref="faqPosition">
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="section-title">
            <h2 class="text-white">Frequently asked Question</h2>
            <div class="line white"></div>
          </div>
        </div>
      </div>
      <div class="row faq-row">
        <div class="col-lg-6">
          <div class="accordion">
            <div class="faqs">
              <faqSection
                v-for="(faq, i) in cards"
                :faq="faq"
                :index="i"
                :key="i"
                :open="faq.open"
                @toggleOpen="toggleOpen"
              />
            </div>
          </div>
        </div>
        <div class="col-lg-6 text-center">
          <img class="img-fluid" src="../../assets/images/faq.png" alt="" />
        </div>
      </div>
    </div>
  </section>
  <!--FAQ end -->
</template>
<script>
import faqSection from "./faqComponent.vue";

export default {
  name: "FAQ",
  components: {
    faqSection,
  },
  data() {
    return {
      cards: [
        {
          id: 1,
          title: "01 We're ready to start now",
          description:
            "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do ei temporoincididunt ut labore et dolore magna aliqua. Ut enim ad minim exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute dolor in reprehenderit in voluptate velit esse cillum dolore",
          open: false,
        },
        {
          id: 2,
          title: "02 Sedeiusmod tm inccsetetur ?",
          description:
            "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do ei temporo incididunt ut labore et dolore magna aliqua. Ut enim ad minim exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute dolor in reprehenderit in voluptate velit esse cillum dolore",
          open: true,
        },
        {
          id: 3,
          title: "03 Sedeiusmod inc aliquatraiy?",
          description:
            "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do ei temporo incididunt ut labore et dolore magna aliqua. Ut enim ad minim exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute dolor in reprehenderit in voluptate velit esse cillum dolore",
          open: false,
        },
        {
          id: 4,
          title: "04 Tempor inc aliquatraiy?",
          description:
            "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do ei temporo incididunt ut labore et dolore magna aliqua. Ut enim ad minim exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute dolor in reprehenderit in voluptate velit esse cillum dolore",
        },
      ],
    };
  },
  methods: {
    toggleOpen(index) {
      this.cards = this.cards.map((faq, i) => {
        if (index === i) {
          faq.open = !faq.open;
        } else {
          faq.open = false;
        }

        return faq;
      });
    },
  },
};
</script>
<style>
.faq {
  display: block;
  width: 100%;
  max-width: 768px;
  margin: 15px auto;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  background-color: #fff;
}

.faq .question {
  position: relative;
  font-size: 16px;
  transition: all 0.4s linear;
}

.faq .question::after {
  content: "";

  position: absolute;
  top: 50%;
  right: 0px;
  transform: translateY(-50%) rotate(0deg);

  width: 30px;
  height: 30px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;

  transition: all 0.2s linear;
}
.faq.open .question {
  margin-bottom: 15px;
}
.faq.open .question::after {
  transform: translateY(-50%) rotate(90deg);
}
.faq .answer {
  font-size: 16px;
  opacity: 0;
  max-height: 0px;
  overflow-y: hidden;
  transition: all 0.4s ease-out;
}
.faq.open .answer {
  opacity: 1;
  max-height: 1000px;
}
</style>
